import { SITE_URL } from '@blind-kings/site-config';

export const HOW_TO_PLAY_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'HowTo',
  name: 'How to play Blind Kings',
  description:
    'Blind Kings is a hidden-piece strategy game. Reveal, move, and attack to conquer your rival kingdom.',
  url: `${SITE_URL}/rules`,
  step: [
    {
      '@type': 'HowToStep',
      position: 1,
      name: 'Reveal',
      text: 'On your turn you may reveal any face-down piece. The first reveal is always the first player’s piece; later flips can belong to either side.',
    },
    {
      '@type': 'HowToStep',
      position: 2,
      name: 'Move',
      text: 'Move one of your revealed pieces into an adjacent empty square.',
    },
    {
      '@type': 'HowToStep',
      position: 3,
      name: 'Attack',
      text: 'Attack an adjacent enemy with equal or lower Combat Power. King, Peasant, and Assassin have special attack rules.',
    },
    {
      '@type': 'HowToStep',
      position: 4,
      name: 'Win',
      text: 'Capture the enemy King, or reduce your rival to no living pieces.',
    },
  ],
} satisfies Record<string, unknown>;
